export default "__VITE_ASSET__Cgk$1S6d__"